import { Suspense, lazy } from 'react';

import { Box } from '@betterment/samba-react';

import successCheckmarkAnimation from './success_checkmark.lottie?url';

const DotLottieReact = lazy(() =>
  import('@lottiefiles/dotlottie-react').then(module => ({
    default: module.DotLottieReact,
  }))
);

const SuccessCheckmark = ({ onAnimationEnd }: { onAnimationEnd?: () => void }) => {
  return (
    <Box css={{ height: '150px', width: '150px', margin: '0 auto' }}>
      <Suspense fallback={<Box css={{ height: '150px', width: '150px' }} />}>
        <DotLottieReact
          src={successCheckmarkAnimation}
          autoplay={true}
          loop={false}
          dotLottieRefCallback={dotLottie => {
            dotLottie?.addEventListener('complete', () => onAnimationEnd?.());
          }}
        />
      </Suspense>
    </Box>
  );
};

export default SuccessCheckmark;
